import Link, { LinkProps as InternalLinkProps } from 'next/link';
import { AnchorHTMLAttributes, RefAttributes } from 'react';

export declare type NextLinkProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  keyof InternalLinkProps
> &
  InternalLinkProps &
  RefAttributes<HTMLAnchorElement>;

export default function NextLink({
  prefetch = false, // disable prefetch by default
  href,
  ...props
}: NextLinkProps) {
  return <Link {...props} prefetch={prefetch} href={href} />;
}
